// Backs the generic first-run "coach mark" popups. Server-side so the
// dismissal survives incognito, other browsers, and phone logins —
// localStorage alone would resurface the hint on every new session.
//
// New hint = new dot-namespaced key ("cc.viewToggle"). No catalog row.
// Wrap the target with <CoachMark hintKey="…"> and the reader takes
// care of everything.
import apiInstance from "./index";

export const UserHintsService = {
  listDismissed: () => apiInstance.get("/user-hints/dismissed"),
  dismiss: (key) => apiInstance.post("/user-hints/dismiss", { key }),
};

export default UserHintsService;
